export const TRANSACTION_TYPE = {
  BUY: {
    status_code: 'BUY',
    description: 'ซื้อ',
  },
  SALE: {
    status_code: 'SALE',
    description: 'ขาย',
  },
};
export default TRANSACTION_TYPE;
